export default __webpack_public_path__ + "media/images/react_icons/arrow-right-black-4843f0bb456bccf930ec3249690228e4.svg";